// extracted by mini-css-extract-plugin
module.exports = {"emptyTableContainer":"ErrorMessage_emptyTableContainer__24UD4","refreshButton":"ErrorMessage_refreshButton__2BEin"};